import { render, staticRenderFns } from "./normalIndex.vue?vue&type=template&id=59902ed6&scoped=true&"
import script from "./normalIndex.vue?vue&type=script&lang=js&"
export * from "./normalIndex.vue?vue&type=script&lang=js&"
import style0 from "./normalIndex.vue?vue&type=style&index=0&id=59902ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59902ed6",
  null
  
)

export default component.exports